import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Sitemap } from '../components/Sitemap';
import { VideoCard } from '../components/VideoCard';
import { Sidebar } from '../components/Sidebar';
import { YouTubeCTA } from '../components/YouTubeCTA';
import { SearchIcon, FilterIcon, GridIcon, ListIcon } from 'lucide-react';
export function EducationalVideosPage() {
  const {
    isArabic
  } = useLanguage();
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const videos = [{
    id: 1,
    title: 'Basic English Greetings',
    titleAr: 'التحيات الأساسية باللغة الإنجليزية',
    thumbnail: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    duration: '5:24',
    category: 'phrases'
  }, {
    id: 2,
    title: 'How to Introduce Yourself',
    titleAr: 'كيفية تقديم نفسك',
    thumbnail: 'https://images.unsplash.com/photo-1507537297725-24a1c029d3ca?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    duration: '8:15',
    category: 'conversation'
  }, {
    id: 3,
    title: 'Common Business English Phrases',
    titleAr: 'عبارات شائعة في الإنجليزية للأعمال',
    thumbnail: 'https://images.unsplash.com/photo-1573164574572-cb89e39749b4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    duration: '12:30',
    category: 'business'
  }, {
    id: 4,
    title: 'Present Simple Tense Explained',
    titleAr: 'شرح زمن المضارع البسيط',
    thumbnail: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    duration: '10:45',
    category: 'grammar'
  }, {
    id: 5,
    title: 'Shopping Vocabulary',
    titleAr: 'مفردات التسوق',
    thumbnail: 'https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    duration: '7:20',
    category: 'phrases'
  }, {
    id: 6,
    title: 'How to Ask Questions in English',
    titleAr: 'كيفية طرح الأسئلة باللغة الإنجليزية',
    thumbnail: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    duration: '9:15',
    category: 'grammar'
  }];
  const filteredVideos = videos.filter(video => {
    const matchesSearch = searchQuery === '' || video.title.toLowerCase().includes(searchQuery.toLowerCase()) || video.titleAr.includes(searchQuery);
    const matchesCategory = selectedCategory === null || video.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });
  return <div className="w-full px-6 md:px-10 lg:px-20 py-16" data-id="element-2764">
      <Sitemap currentPage={{
      en: 'Educational Videos',
      ar: 'الفيديوهات التعليمية'
    }} breadcrumbs={[{
      label: {
        en: 'Learn',
        ar: 'تعلم'
      },
      href: '/learn'
    }]} data-id="element-2765" />
      <div className="max-w-7xl mx-auto" data-id="element-2766">
        <div className="text-center mb-12" data-id="element-2767">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-2768">
            {isArabic ? 'الفيديوهات التعليمية' : 'Educational Videos'}
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-2769">
            {isArabic ? 'تعلم اللغة الإنجليزية من خلال دروس الفيديو التفاعلية' : 'Learn English through interactive video lessons'}
          </p>
        </div>
        <div className="flex flex-col md:flex-row gap-8" data-id="element-2770">
          <div className="md:w-1/4" data-id="element-2771">
            <Sidebar data-id="element-2772" />
          </div>
          <div className="md:w-3/4" data-id="element-2773">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8" data-id="element-2774">
              <div className="relative w-full sm:w-auto" data-id="element-2775">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2776">
                  <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-2777" />
                </div>
                <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder={isArabic ? 'ابحث عن الفيديوهات...' : 'Search videos...'} className="w-full sm:w-64 pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white" data-id="element-2778" />
              </div>
              <div className="flex items-center gap-2" data-id="element-2779">
                <button onClick={() => setViewMode('grid')} className={`p-2 rounded-lg ${viewMode === 'grid' ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400' : 'bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400'}`} data-id="element-2780">
                  <GridIcon className="w-5 h-5" data-id="element-2781" />
                </button>
                <button onClick={() => setViewMode('list')} className={`p-2 rounded-lg ${viewMode === 'list' ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400' : 'bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400'}`} data-id="element-2782">
                  <ListIcon className="w-5 h-5" data-id="element-2783" />
                </button>
              </div>
            </div>
            {filteredVideos.length > 0 ? <div className={`grid gap-6 ${viewMode === 'grid' ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3' : 'grid-cols-1'}`} data-id="element-2784">
                {filteredVideos.map(video => <VideoCard key={video.id} id={video.id} title={video.title} titleAr={video.titleAr} thumbnail={video.thumbnail} duration={video.duration} category={video.category} data-id="element-2785" />)}
              </div> : <div className="text-center py-12" data-id="element-2786">
                <p className="text-gray-500 dark:text-gray-400" data-id="element-2787">
                  {isArabic ? 'لا توجد فيديوهات تطابق بحثك' : 'No videos match your search'}
                </p>
              </div>}
            <div className="mt-12" data-id="element-2788">
              <YouTubeCTA data-id="element-2789" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}